export default __webpack_public_path__ + "static/filewithorangedust-87beffeeb58106171cb3cb3be4b47bee.png";